<!--  -->
<template>
  <a-form layout="vertical" v-if="data" :key="data.key">
    <a-form-item
      label="占位内容"
      v-if="hasKey('placeholder') && data.type==='input' || data.type === 'textarea'"
    >
      <a-input v-model:value="data.options.placeholder" />
    </a-form-item>
    <a-form-item
      label="默认内容"
      v-if="hasKey('defaultValue') && data.type==='input' || data.type === 'textarea' || data.type === 'text'"
    >
      <a-textarea v-model:value="data.options.defaultValue" />
      <!-- <a-input v-model:value="data.options.defaultValue" /> -->
    </a-form-item>
    <a-form-item label="key">
      <a-input
        v-model:value="data.labelKey"
        @change="labelChange"
      />
    </a-form-item>
    <a-form-item label="标题">
      <a-input v-model:value="data.label" />
    </a-form-item>
    <a-form-item label="选项" v-if="hasKey('options')">
      <template v-if="data.type==='radio'">
        <a-radio-group v-model:value="data.options.defaultValue">
          <div v-for="(element,index) in data.options.options" :key="index">
            <a-radio :value="element.id" style="margin-right: 0px;">
              <a-input
                size="small"
                :style="{
                        width: data.options.showLabel ? '90px' : '180px'
                      }"
                v-model:value="element.value"
              />
              <a-input
                size="small"
                :style="{
                        width: data.options.showLabel ? '90px' : '0',
                        padding: data.options.showLabel ? '0 7px' : '0',
                        border: data.options.showLabel
                          ? '1px solid #d9d9d9'
                          : 'none'
                      }"
                v-model:value="element.label"
              />
            </a-radio>
            <a-button
              type="primary"
              shape="circle"
              size="small"
              style="margin-left: 10px;"
              @click="handleOptionsRemove(index)"
            >
              <template #icon>
                <Icon :icon="'delete-bin-6-line'" />
              </template>
            </a-button>
          </div>
        </a-radio-group>
        <div style="margin-top: 5px;">
          <a-button type="link" size="small" @click="handleInsertOption">添加选项</a-button>
        </div>
      </template>
      <template v-if="data.type==='checkbox'">
        <a-checkbox-group v-model:value="data.options.defaultValue">
          <div v-for="(element,index) in data.options.options" :key="index">
            <a-checkbox :value="element.value" style="margin-right: 0;">
              <a-input
                size="small"
                :style="{
                        width: data.options.showLabel ? '90px' : '180px'
                      }"
                v-model:value="element.value"
              />
              <a-input
                size="small"
                :style="{
                        width: data.options.showLabel ? '90px' : '0',
                        padding: data.options.showLabel ? '0 7px' : '0',
                        border: data.options.showLabel
                          ? '1px solid #d9d9d9'
                          : 'none'
                      }"
                v-model:value="element.label"
              />
            </a-checkbox>
            <a-button
              type="primary"
              shape="circle"
              size="small"
              style="margin-left: 10px;"
              @click="handleOptionsRemove(index)"
            >
              <template #icon>
                <Icon :icon="'delete-bin-6-line'" />
              </template>
            </a-button>
          </div>
          <div style="margin-top: 5px;">
            <a-button type="link" size="small" @click="handleInsertOption">添加选项</a-button>
          </div>
        </a-checkbox-group>
      </template>
    </a-form-item>
  </a-form>
</template>

<script>
import { defineComponent, ref, watch, computed } from "vue";
import Icon from "@/layout/icon";
export default defineComponent({
  name: "widgetConfig",
  props: {
    select: {
      type: Object
    }
  },
  components: {
    Icon
  },
  emits: ["update:select"],
  setup(props, context) {
    const data = ref(props.select);
    watch(
      () => props.select,
      val => (data.value = val)
    );
    watch(data, val => context.emit("update:select", val));
    const hasKey = key => Object.keys(data.value.options).includes(key);
    const handleOptionsRemove = index => {
      data.value.options.options.splice(index, 1);
    };
    const labelChange = (e) => {
      data.value.labelKey = data.value.labelKey.replace(/[\u4E00-\u9FA5]/g,'')
    }
    const handleInsertOption = () => {
      const index = data.value.options.options.length + 1;
      data.value.options.options.push({
        label: `Option ${index}`,
        value: `Option ${index}`,
        selected: false,
        id: index - 1
      });
    };
    return {
      data,
      hasKey,
      handleOptionsRemove,
      handleInsertOption,
      labelChange
    };
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>